var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { NetworkError, ValidationError, AuthError, AppError, } from './errors/api.errors';
export var axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_URL_API,
});
axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a, _b;
    if (!error.response) {
        return Promise.reject(new NetworkError());
    }
    switch (error.response.status) {
        case 400:
            return Promise.reject(new ValidationError(((_a = error.response.data) === null || _a === void 0 ? void 0 : _a.message) || 'Invalid request.', error.response));
        case 401:
            return Promise.reject(new AuthError('Unauthorized access. Please login again.'));
        default:
            return Promise.reject(new AppError(((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message) || 'An unexpected error occurred.', error.response.status));
    }
});
export var api = {
    setAuthorizationToken: function (authProvider, token) {
        axiosInstance.defaults.headers.common['auth-provider'] = authProvider;
        axiosInstance.defaults.headers.common.Authorization = "Bearer ".concat(token);
    },
    get: function (url, config) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosInstance.get(url, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    delete: function (url, config) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosInstance.delete(url, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    post: function (url, data, config) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosInstance.post(url, data, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    put: function (url, data, config) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosInstance.put(url, data, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
    patch: function (url, data, config) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axiosInstance.patch(url, data, config)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    },
};
